import React, { useState, useEffect } from 'react';
import noProfile from '../../Images/noProfile.png';
import { useAuth } from '../../Context';
import {
    Row,
    Col,
    Button,
    Card,
    Input,
    Form,
    Select,
    Radio,
    DatePicker,
    Avatar,
    message
} from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import nationality from '../../JSON/nationality.json';
import initialJson from '../../JSON/initials.json';
import { useDispatch, useSelector } from 'react-redux';
import { getCountriesRequest, patientDetailsRequest, updateFamilyMemberRequest } from './Actions';
import { selectCountryDetails, selectLoading, selectPatientDetails, selectFamilyTreeState } from './Selectors';
import { useNavigate, useParams } from 'react-router-dom';
import CustomSpin from '../CommonSpin';
import { BodyTextHeading } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;
const dateFormat = 'DD-MM-YYYY';
const RadioGroup = Radio.Group;

const EditFamilyMember = () => {
    const [selectedInitials, setSelectedInitials] = useState('Mr.');
    const { memberId } = useParams();
    const formRef = React.useRef(null);
    const [form] = Form.useForm();
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const [fileUpload, setFileUpload] = useState(null);


    const dispatch = useDispatch();
    const navigate = useNavigate();


    const requesting = useSelector(selectLoading);
    const countries = useSelector(selectCountryDetails);    
    const memberDetails = useSelector(selectPatientDetails);
    const familyTreeState = useSelector(selectFamilyTreeState);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    const {profileGet, patientDeatils} = useAuth();
    const profiles = patientDeatils && patientDeatils ? patientDeatils[0] : null;
    

    useEffect(() => {
        dispatch(getCountriesRequest());
        if (memberId) {
            dispatch(patientDetailsRequest(memberId));
        }
    }, [dispatch, memberId]);

    useEffect(() => {
        profileGet();
    }, []);

    useEffect(() => {
        if (memberDetails && typeof memberDetails === 'object' && Object.keys(memberDetails).length > 0 && formRef.current) {
            const data = memberDetails;
            
            // Convert ISO date to dayjs
            const parsedDate = data.dob ? dayjs(data.dob) : null;
            
            formRef.current.setFieldsValue({
                id : profiles && profiles.id,
                relationship: data.relationShip,
                firstName: data.firstName,
                lastName: data.lastName,
                gender: data.gender,
                address: data.address,
                Country: data.nationality,
                resident: data.residentCountry,
                bloodGroup: data.bloodGroup,
                dateOfBirth: parsedDate,
                image : fileUpload ? fileUpload : null
            });
            setSelectedInitials(data.initials || 'Mr.');
        }
    }, [memberDetails, formRef]);

    useEffect(() => {
        if (familyTreeState.successMessage === langdata.FamilyMemberUpdateSuccess) {
            navigate('/familytree');
        }
    }, [familyTreeState.successMessage, navigate]);

    const handleSubmit = (value) => {
        
        dispatch(updateFamilyMemberRequest({ ...value, initials: selectedInitials }, memberId, {image : fileUpload ? fileUpload : null}));
    };

    const disabledDate = (current) => {
        return current > moment().subtract(1, 'days').endOf('day');
    };

    const validator = (rule, value) => {
        if (value && value.length < 3) {
            return Promise.reject(langdata.FirstNameValidation);
        }
        return Promise.resolve();
    };

    const onSelect = (value, abc) => {
        localStorage.setItem('COUNTRY_CODE', abc.props.abc);
    };

    const nationa = nationality.map((item, i) => (
        <Option key={i} value={item}>
            {item}
        </Option>
    ));

    const country = countries?.map((item, i) => (
        <Option key={i} value={item.name} abc={item.countryCallingCodes[0]}>
            {item.name}
        </Option>
    ));

    const initialsSelectOptions = initialJson.map((itm) => (
        <Option key={itm} value={itm}>
            {itm}
        </Option>
    ));

    const handleInitials = (value) => {
        setSelectedInitials(value);
    };

    const initialsDropdown = (
        <Select value={selectedInitials} onChange={handleInitials} style={{ width: '80px' }}>
            {initialsSelectOptions}
        </Select>
    );

    const handleImageChange = (event) => {
        const reader = new FileReader();
        const file = event.target.files[0];
        if (file && file !== null) { 
            if (file && (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg')) {
                reader.onloadend = () => {
                    setImagePreviewUrl(reader.result);
                    setFileUpload(file);
                };


            }
            else {
                message.error('Please upload a valid image file (JPEG or PNG)');
            }
            reader.readAsDataURL(file);
        } else {
            message.error('File is not chosen');
        }
    };

    return (
        <div style={{ paddingBottom: '20px' }}>
            <Row type="flex" justify="center" style={{ marginTop: '10px' }}>
                <Col xs={{ span: 22 }} md={{ span: 14 }} lg={{ span: 16 }} xl={{ span: 16 }} xxl={{ span: 16 }}>
                    <Card style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)', borderRadius: '4px' }}>
                        <div style={{ marginBottom: '20px' }}><BodyTextHeading text={langdata.EditFamilyMember} /></div>

                        {/* Profile Picture Section */}
                        <Row justify="center" style={{ marginBottom: '20px' }}>
                            <Col span={24} style={{ textAlign: 'center' }}>
                                <Avatar
                                    style={{ width: '120px', height: '120px' }}
                                    src={
                                        imagePreviewUrl !== null
                                            ? imagePreviewUrl
                                            : memberDetails && memberDetails.profilephotourl
                                                ? memberDetails.profilephotourl
                                                : noProfile
                                    }
                                />
                                <div style={{ marginTop: '10px' }}>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: '#1164A6',
                                            borderColor: '#ffffff',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <span style={{ color: '#ffffff' }}>{`${langdata.ChangePhoto ? langdata.ChangePhoto : 'Change Photo'}`}</span>
                                        <input
                                            style={{
                                                opacity: '0',
                                                width: '120px',
                                                marginLeft: '-125px',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                display: 'flex'
                                            }}
                                            type="file"
                                            accept="image/png, image/jpg, image/jpeg"
                                            id="profilePhotoInput"
                                            onChange={handleImageChange}
                                        />
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Form form={form} onFinish={handleSubmit} ref={formRef}>
                            <Form.Item label={`${langdata.Relationship ? langdata.Relationship : 'Relationship' }`} hasFeedback name="relationship" rules={[{ required: true, message: 'Please select your relationship!' }]}>
                                <Select placeholder={`${langdata.Pleaseselectrelationship ? langdata.Pleaseselectrelationship : 'Please select relationship' }`} disabled={memberDetails?.data?.isParent}>
                                    <Option value={'Father'}>Father</Option>
                                    <Option value={'Mother'}>Mother</Option>
                                    <Option value={'Husband'}>Husband</Option>
                                    <Option value={'Wife'}>Wife</Option>
                                    <Option value={'Son'}>Son</Option>
                                    <Option value={'Daughter'}>Daughter</Option>
                                    <Option value={'Other'}>Other</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item 
                                label={`${langdata.FirstName ? langdata.FirstName : 'First Name' }`} 
                                name="firstName"
                                rules={[{ required: true, message: 'Please input your First Name', whitespace: true }, { validator }]}
                                hasFeedback
                            >
                                <Input 
                                    addonBefore={initialsDropdown} 
                                    placeholder={`${langdata.FirstName ? langdata.FirstName : 'First Name' }`} 
                                    style={{ width: '100%' }} 
                                />
                            </Form.Item>

                            <Form.Item label={`${langdata.LastName ? langdata.LastName : 'Last Name' }`} hasFeedback name="lastName" rules={[{ required: true, message: 'Please input your Last Name', whitespace: true }]}>
                                <Input placeholder={`${langdata.LastName ? langdata.LastName : 'Last Name' }`} />
                            </Form.Item>

                            <Form.Item label={`${langdata.Gender ? langdata.Gender : 'Gender' }`} hasFeedback name="gender" rules={[{ required: true, message: 'Please Select Gender!' }]}>
                                <RadioGroup style={{ paddingRight: '15px' }}>
                                    <Radio value={'Male'}>{`${langdata.Male ? langdata.Male : 'Male' }`}</Radio>
                                    <Radio value={'Female'}>{`${langdata.Female ? langdata.Female : 'Female' }`}</Radio>
                                    <Radio value={'Others'}>{`${langdata.Others ? langdata.Others : 'Others' }`}</Radio>
                                </RadioGroup>
                            </Form.Item>

                            <Form.Item label={`${langdata.PresentAddress ? langdata.PresentAddress : 'Present Address' }`} hasFeedback name="address" rules={[{ required: false }]}>
                                <Input placeholder={`${langdata.PresentAddress ? langdata.PresentAddress : 'Present Address' }`} />
                            </Form.Item>

                            <Form.Item label={`${langdata.Nationality ? langdata.Nationality : 'Nationality' }`} hasFeedback name="Country" rules={[{ required: false, message: 'Please select your Nationality!' }]}>
                                <Select showSearch placeholder={`${langdata.PleaseselectaNationality ? langdata.PleaseselectaNationality : 'Please select a Nationality' }`} optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {nationa}
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.CountryofResidence ? langdata.CountryofResidence : 'Country of Residence'  }`} hasFeedback name="resident" rules={[{ required: false, message: 'Please select your Country of Residence!' }]}>
                                <Select
                                    showSearch
                                    onSelect={onSelect}
                                    placeholder={`${langdata.PleaseselectCountryofResidence ? langdata.PleaseselectCountryofResidence : 'Please select Country of Residence' }`}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {country}
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group' }`} hasFeedback name="bloodGroup" rules={[{ required: false, message: 'Please select your Blood Group!' }]}>
                                <Select placeholder={`${langdata.PleaseselectBloodGroup ? langdata.PleaseselectBloodGroup : 'Please select Blood Group' }`}>
                                    <Option value={'A+'}>A+</Option>
                                    <Option value={'A-'}>A-</Option>
                                    <Option value={'B+'}>B+</Option>
                                    <Option value={'B-'}>B-</Option>
                                    <Option value={'O+'}>O+</Option>
                                    <Option value={'O-'}>O-</Option>
                                    <Option value={'AB+'}>AB+</Option>
                                    <Option value={'AB-'}>AB-</Option>
                                    <Option value={'Not Specified'}>Not Specified</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth'}`} name="dateOfBirth" rules={[{ required: true, message: 'Please select your Date of Birth!' }]}>
                                <DatePicker 
                                    disabledDate={disabledDate} 
                                    format={dateFormat} 
                                    placeholder={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth'}`}
                                    // onChange={(date) => {
                                    //      console.log("Selected date:", date?.format('YYYY-MM-DD'));
                                    // }}
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button style={{ marginRight: '8px' }} onClick={() => navigate('/familytree')}>
                                    {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`}
                                </Button>
                                <Button type="primary" htmlType="submit">
                                    {langdata.Update}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
            <CustomSpin spinning={requesting} />            
        </div>
    );
};

export default EditFamilyMember; 